import { render, staticRenderFns } from "./FacebookPreview.vue?vue&type=template&id=25107b0e&"
import script from "./FacebookPreview.vue?vue&type=script&lang=js&"
export * from "./FacebookPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports